import React from 'react';
import { View, Text, Image, StyleSheet } from '@react-pdf/renderer';
import { colors, typography, spacing } from '../styles/theme';

const styles = StyleSheet.create({
  container: {
    marginVertical: spacing.md,
  },
  title: {
    ...typography.subsection,
    marginBottom: spacing.sm,
  },
  chartWrapper: {
    backgroundColor: colors.background.white,
    padding: spacing.sm,
    borderWidth: 1,
    borderColor: colors.border.light,
    borderStyle: 'solid',
  },
  chart: {
    width: '100%',
  },
  description: {
    ...typography.chartDescription,
  },
  // With legend variant
  chartWithLegend: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  chartArea: {
    flex: 1,
  },
  legendArea: {
    width: 120,
    paddingLeft: spacing.md,
  },
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: spacing.xs,
  },
  legendColor: {
    width: 12,
    height: 12,
    marginRight: spacing.xs,
  },
  legendText: {
    fontSize: 8,
    color: colors.text.secondary,
    flex: 1,
  },
  legendValue: {
    fontSize: 8,
    color: colors.text.muted,
    marginLeft: spacing.xs,
  },
});

const ChartContainer = ({
  title,
  description,
  chartImage,
  chartHeight = 'auto',
  legend,
  style,
}) => {
  const hasLegend = legend && legend.length > 0;

  return (
    <View style={[styles.container, style]}>
      {title && <Text style={styles.title}>{title}</Text>}

      {hasLegend ? (
        <View style={styles.chartWithLegend}>
          <View style={styles.chartArea}>
            <View style={styles.chartWrapper}>
              {chartImage && (
                <Image
                  style={[styles.chart, { height: chartHeight }]}
                  src={chartImage}
                />
              )}
            </View>
          </View>
          <View style={styles.legendArea}>
            {legend.map((item, idx) => (
              <View key={idx} style={styles.legendItem}>
                <View
                  style={[styles.legendColor, { backgroundColor: item.color }]}
                />
                <Text style={styles.legendText}>{item.label}</Text>
                {item.value !== undefined && (
                  <Text style={styles.legendValue}>{item.value}</Text>
                )}
              </View>
            ))}
          </View>
        </View>
      ) : (
        <View style={styles.chartWrapper}>
          {chartImage && (
            <Image
              style={[styles.chart, { height: chartHeight }]}
              src={chartImage}
            />
          )}
        </View>
      )}

      {description && <Text style={styles.description}>{description}</Text>}
    </View>
  );
};

export default ChartContainer;
